import observeClientPage from './observeClientPage';
import notifyClientPage from './notifyClientPage';
import getWidgetData from './getWidgetData';
import loadButtons  from './loadButtons';
import launchWidget from './launchWidget';
import initWidget from './initWidget';
import showWidget from './showWidget';
import closeWidget from './closeWidget';
import openDeviceCalendar from './openDeviceCalendar';
import weblog, { initWeblog } from './weblog';
import locationAssign from './locationAssign';
// client listeners will be called from the client page.
import initWidgetSettings from './initWigetSettings';
import previewUpdateWidgetSettings from './previewUpdateWidgetSettings';
import oauthSessionReady from './oauthSessionReady';
/*
 * AppClient Store connects the React App and the Client Page Buttons
 * And through this we can send message to Ecal Widget JS
 */
export const actions = {
    observeClientPage,
    notifyClientPage,
    getWidgetData,
    loadButtons,
    launchWidget,
    initWidgetSettings,
    initWidget,
    showWidget,
    closeWidget,
    openDeviceCalendar,
    weblog,
    initWeblog,
    locationAssign,
    previewUpdateWidgetSettings,
    oauthSessionReady,
};

export default actions;
